import * as Mod1 from "./discourse/admin-discourse-showcase-plugin-route-map";
import * as Mod2 from "./discourse/components/reviewable/dsc-item";
import * as Mod3 from "./discourse/connectors/before-composer-fields/showcase-composer-fields.gjs";
import * as Mod4 from "./discourse/connectors/full-page-search-before-results/discourse-showcase-results.gjs";
import * as Mod5 from "./discourse/connectors/search-menu-results-bottom/discourse-showcase-results.gjs";
import * as Mod6 from "./discourse/connectors/user-activity-bottom/showcase-list.gjs";
import * as Mod7 from "./discourse/controllers/admin-plugins/show/discourse-showcase-items";
import * as Mod8 from "./discourse/controllers/discourse-showcase-edit";
import * as Mod9 from "./discourse/controllers/discourse-showcase-item";
import * as Mod10 from "./discourse/controllers/discourse-showcase-new";
import * as Mod11 from "./discourse/controllers/discourse-showcase-user";
import * as Mod12 from "./discourse/controllers/discourse-showcase";
import * as Mod13 from "./discourse/controllers/user-activity/showcase";
import * as Mod14 from "./discourse/discourse-showcase-route-map";
import * as Mod15 from "./discourse/discourse-showcase-user-activity-route-map";
import * as Mod16 from "./discourse/initializers/discourse-showcase-admin-plugin-configuration-nav";
import * as Mod17 from "./discourse/initializers/discourse-showcase-composer";
import * as Mod18 from "./discourse/initializers/discourse-showcase-sidebar";
import * as Mod19 from "./discourse/lib/discourse-showcase-upload";
import * as Mod20 from "./discourse/routes/admin-plugins/show/discourse-showcase-items";
import * as Mod21 from "./discourse/routes/discourse-showcase-edit";
import * as Mod22 from "./discourse/routes/discourse-showcase-item";
import * as Mod23 from "./discourse/routes/discourse-showcase-new";
import * as Mod24 from "./discourse/routes/discourse-showcase-user";
import * as Mod25 from "./discourse/routes/discourse-showcase";
import * as Mod26 from "./discourse/routes/user-activity/showcase";
import * as Mod27 from "./discourse/templates/admin-plugins/show/discourse-showcase-items";
import * as Mod28 from "./discourse/templates/discourse-showcase-edit";
import * as Mod29 from "./discourse/templates/discourse-showcase-item";
import * as Mod30 from "./discourse/templates/discourse-showcase-new";
import * as Mod31 from "./discourse/templates/discourse-showcase-user";
import * as Mod32 from "./discourse/templates/discourse-showcase";
import * as Mod33 from "./discourse/templates/user-activity/showcase";
const compatModules = {
  "discourse/admin-discourse-showcase-plugin-route-map": Mod1,
  "discourse/components/reviewable/dsc-item": Mod2,
  "discourse/connectors/before-composer-fields/showcase-composer-fields": Mod3,
  "discourse/connectors/full-page-search-before-results/discourse-showcase-results": Mod4,
  "discourse/connectors/search-menu-results-bottom/discourse-showcase-results": Mod5,
  "discourse/connectors/user-activity-bottom/showcase-list": Mod6,
  "discourse/controllers/admin-plugins/show/discourse-showcase-items": Mod7,
  "discourse/controllers/discourse-showcase-edit": Mod8,
  "discourse/controllers/discourse-showcase-item": Mod9,
  "discourse/controllers/discourse-showcase-new": Mod10,
  "discourse/controllers/discourse-showcase-user": Mod11,
  "discourse/controllers/discourse-showcase": Mod12,
  "discourse/controllers/user-activity/showcase": Mod13,
  "discourse/discourse-showcase-route-map": Mod14,
  "discourse/discourse-showcase-user-activity-route-map": Mod15,
  "discourse/initializers/discourse-showcase-admin-plugin-configuration-nav": Mod16,
  "discourse/initializers/discourse-showcase-composer": Mod17,
  "discourse/initializers/discourse-showcase-sidebar": Mod18,
  "discourse/lib/discourse-showcase-upload": Mod19,
  "discourse/routes/admin-plugins/show/discourse-showcase-items": Mod20,
  "discourse/routes/discourse-showcase-edit": Mod21,
  "discourse/routes/discourse-showcase-item": Mod22,
  "discourse/routes/discourse-showcase-new": Mod23,
  "discourse/routes/discourse-showcase-user": Mod24,
  "discourse/routes/discourse-showcase": Mod25,
  "discourse/routes/user-activity/showcase": Mod26,
  "discourse/templates/admin-plugins/show/discourse-showcase-items": Mod27,
  "discourse/templates/discourse-showcase-edit": Mod28,
  "discourse/templates/discourse-showcase-item": Mod29,
  "discourse/templates/discourse-showcase-new": Mod30,
  "discourse/templates/discourse-showcase-user": Mod31,
  "discourse/templates/discourse-showcase": Mod32,
  "discourse/templates/user-activity/showcase": Mod33,
};
export { compatModules };
export default compatModules;
